import {
    EmojiHappy,
    EmojiNormal,
    EmojiSad,
    Star1,
    TickSquare,
} from "iconsax-react";

const PREVIEW_COLOR = "#f5a524";

function NumericPreview({ count = 3, start = 1 }) {
    return (
        <div className="answer-type-preview-numeric">
            {Array.from({ length: count }, (_, index) => (
                <span key={start + index}>{start + index}</span>
            ))}
        </div>
    );
}

function ChoicePreview() {
    return (
        <div className="answer-type-preview-choice">
            <span className="is-on" />
            <span />
            <span />
        </div>
    );
}

function YesNoPreview() {
    return (
        <div className="answer-type-preview-yesno">
            <i />
            <i />
        </div>
    );
}

function LikertPreview() {
    return (
        <div className="answer-type-preview-likert">
            <span />
            <span />
            <span className="is-on" />
            <span />
            <span />
        </div>
    );
}

function CsatPreview() {
    return (
        <div className="answer-type-preview-csat">
            <TickSquare variant="Bold" size={18} color={PREVIEW_COLOR} />
            <TickSquare variant="Bold" size={18} color={PREVIEW_COLOR} />
            <TickSquare variant="Bold" size={18} color={PREVIEW_COLOR} />
        </div>
    );
}

function NpsPreview() {
    return (
        <div className="answer-type-preview-nps">
            <span>0</span>
            <em />
            <span>10</span>
        </div>
    );
}

function EmojiPreview() {
    return (
        <div className="answer-type-preview-emoji">
            <EmojiSad variant="Bold" size={20} color={PREVIEW_COLOR} />
            <EmojiNormal variant="Bold" size={20} color={PREVIEW_COLOR} />
            <EmojiHappy variant="Bold" size={20} color={PREVIEW_COLOR} />
        </div>
    );
}

function StarPreview() {
    return (
        <div className="answer-type-preview-star">
            <Star1 variant="Bold" size={18} color={PREVIEW_COLOR} />
            <Star1 variant="Bold" size={18} color={PREVIEW_COLOR} />
            <Star1 variant="Bold" size={18} color={PREVIEW_COLOR} />
        </div>
    );
}

function SliderPreview() {
    return (
        <div className="answer-type-preview-slider">
            <div />
        </div>
    );
}

const PREVIEWS = {
    numeric: () => <NumericPreview />,
    choice: ChoicePreview,
    yesno: YesNoPreview,
    likert: LikertPreview,
    csat: CsatPreview,
    nps: NpsPreview,
    emoji: EmojiPreview,
    star: StarPreview,
    slider: SliderPreview,
};

export default function AnswerTypePreview({ kind }) {
    const Preview = PREVIEWS[kind] || ChoicePreview;
    return (
        <span className={`answer-type-preview is-${kind || "choice"}`}>
            <Preview />
        </span>
    );
}
